import React from "react";
import {  SHIPPING } from "../helpers";

export default function Banner() {
  return (
    <div className="banner-info">
      <div className="item">
        <i className="fas fa-shipping-fast"></i> <span>ENVÍOS SEGUROS A CUALQUIER PARTE DEL MUNDO {SHIPPING} $USD</span>
      </div>

      <div className="item">
        <i className="fas fa-hand-holding-usd"></i>{" "}
        <span>OBTIENES EL TOKEN NATIVO $STORE DE LA TIENDA CON CADA COMPRA QUE HAGAS</span>
      </div>

      <div className="item">
        <i className="fas fa-shield-alt"></i>{" "}
        <span>PAGOS SEGUROS GRACIAS A LA TECNOLOGIA BLOCKCHAIN (BSC)</span>
      </div>
    </div>
  );
}
